import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isObservable } from 'rxjs';
import { map } from 'rxjs/operators';

export function irisTranslationServiceProxy(): TranslateService {
  const translateService = inject(TranslateService, { skipSelf: true });

  return new Proxy(translateService, {
    get(target: TranslateService, prop: string | symbol, receiver: unknown) {
      const value = Reflect.get(target, prop, receiver) as unknown;

      if (typeof prop === 'string' && typeof value === 'function' && (prop === 'get' || prop === 'instant')) {
        return (...args: unknown[]) => {
          const key = args[0];
          const result = (value as (...args: unknown[]) => unknown).apply(target, args) as unknown;

          if (prop === 'get' && isObservable(result)) {
            return result.pipe(
              map((translatedValue: unknown) => {
                if (typeof translatedValue === 'object' && translatedValue != null && !Array.isArray(translatedValue)) {
                  return key; // return the searched 'key' if the result is an object
                }
                return translatedValue; // return original value if it's not problematic
              }),
            );
          }

          if (prop === 'instant') {
            if (typeof result === 'object' && result !== null && !Array.isArray(result)) {
              return key; // return the searched 'key' if the result is an object
            }
          }
          return result; // return original value if it's not problematic
        };
      }
      // end of fix;
      return value;
    },
  });
}
